var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicalSpecialistCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "medical-specialist-cross_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#35a4dd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 65,
    d: "M40.8 921.4s-24.5-195 148.3-343.3S575.5 490 575.5 490s36.8 6.4 86.2 30.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#35a4dd",
    d: "M469.1 65.8c50.3 0 97.6 19.6 133.2 55.2 35.6 35.6 55.2 82.9 55.2 133.2s-19.6 97.6-55.2 133.2c-35.6 35.6-82.9 55.2-133.2 55.2-50.3 0-97.6-19.6-133.2-55.2s-55.2-82.9-55.2-133.2c0-50.3 19.6-97.6 55.2-133.2 35.6-35.6 82.9-55.2 133.2-55.2m0-65C329.2.8 215.7 114.2 215.7 254.2c0 139.9 113.4 253.4 253.4 253.4 139.9 0 253.4-113.4 253.4-253.4C722.5 114.3 609 .8 469.1.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f9af17",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 65,
    d: "M709.4 602.2h169.1v107.1h107.4v170.1H878.8v106.7H709.4V879.2H602V709.5h106.9V602.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalSpecialistCross);
export default ForwardRef;